import {
  CollectorListResponse,
  collectorListResponseSchema,
} from '@/features/collectors/services/schemas.ts';
import { ApiClient } from '@/common/api/ApiClient.ts';

export const CollectorService = {
  list: async (): Promise<CollectorListResponse> => {
    return await ApiClient.get('/collectors', collectorListResponseSchema);
  },
};
